import { render, staticRenderFns } from "./InstallDialog.vue?vue&type=template&id=1f2d91cc&"
import script from "./InstallDialog.vue?vue&type=script&lang=js&"
export * from "./InstallDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports